import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DialogService} from "../../../../ng2-bootstrap-modal/dialog.service";
import {filter, first, switchMap} from "rxjs/operators";
import {Store} from "@ngrx/store";
import * as fromStore from '../../../store';
import {Utils} from "../../../shared/utils/utils";
import {GoogleAnalyticsService} from "../../../shared/services/google-analytics/google-analytics.service";
import {RouteDataService} from "../../../shared/services/route-data/route-data.service";
import {UserSubscription} from "../../../user/user-subscription";


@Component({
    selector: 'db-migration-only-dialog',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './migrate-only.component.html',
    styleUrls: ['./migrate-only.component.scss'],
    standalone: false
})
export class MigrateOnlyDialogComponent implements OnInit {

  @Output() download: EventEmitter<void> = new EventEmitter<void>();
  @Output() showComponent: EventEmitter<any>;
  @Output() blocker = new EventEmitter<any>();
  @Output() closeDialog = new EventEmitter<any>();
  @Output() buttonEvent = new EventEmitter<string>();
  @Output() width = new EventEmitter<any>();
  @Input() componentDataMap: any;
  @Input() hasBackButton?: boolean = true;
  @Input() hostingsLimit?: any;
  @Input() hostedWebsitesCount?: any = 0;
  @Input() currentSubscription?: UserSubscription;
  public managerLink: string;
  public pageId: string;
  public isMobile: boolean = false;
  public blankWebsite: string[] = ['Non-realistic conditions', 'Pre-optimized website templates',
    'Max 30Mb of files', 'No installed plugins'];

  constructor(
    private _dialogService: DialogService,
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _routeDataService: RouteDataService,
    private _store: Store<any>
  ) {
    this.showComponent = new EventEmitter<any>();
  }

  public back() {
    this.showComponent.emit('add-website-choice-activation-flow');
    this.width.emit('680px');
  }

  ngOnInit() {
    this.pageId = this._routeDataService.getCurrentRouteData().pageId;
    this.showComponent.emit('migration-only-dialog');
    this.blocker.emit(false);

    if ((Utils.checkDevice() && window.innerWidth <= 1024)) {
      this.isMobile = true;
    }

    this._store.select(fromStore.getTenWebProductsLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getTenWebManagerPlugin)),
        first()
      ).subscribe(managerPlugin => {
      this.managerLink = managerPlugin && managerPlugin.downloadLink;
    });
  }

  public downloadPlugin() {
    this.download.emit();
    const analyticsData = {
      eventCategory: 'Dashboard Action',
      eventAction: "10Web Manager Download",
      eventLabel: this.pageId === 'websites' ? 'website listing' : (this.pageId === 'main' || this.pageId === 'hosting-performance') ? 'Frontend Booster Features List' : 'download action'
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }
}
